import template from 'es6-template-strings'

class Translations {
  loadTranslations(translations) {
    this.translations = translations
  }

  getTranslations() {
    return this.translations
  }

  setLocale(locale) {
    this.locale = locale
  }

  getLocale() {
    return this.locale
  }

  t(key, params) {
    const result = `${this.locale}.${key}`
      .split('.')
      .reduce((nestedObject, key) => {
        if (nestedObject && key in nestedObject) {
          if (typeof nestedObject[key] === 'string')
            return template(nestedObject[key], params)
          else return nestedObject[key]
        }
        return undefined
      }, this.translations)
    return result || key
  }
}

export let I18n = new Translations()



// WEBPACK FOOTER //
// ./src/lib/i18n.js